import { ElementRef, EventEmitter, Renderer2 } from '@angular/core';
var QuestionnaireTagComponent = (function () {
    function QuestionnaireTagComponent(el, renderer) {
        this.el = el;
        this.renderer = renderer;
        this.outPutSelectedTag = new EventEmitter(); //回传标签
        this.selectedTag = ""; //用户选择的标签
    }
    QuestionnaireTagComponent.prototype.ngOnInit = function () {
    };
    QuestionnaireTagComponent.prototype.ngAfterViewInit = function () {
    };
    QuestionnaireTagComponent.prototype.ngOnChanges = function (changes) {
        if (changes.questionnaireContext && changes.questionnaireContext.currentValue !== '') {
            localStorage.setItem('inputContext', this.questionnaireContext);
        }
    };
    // 选择标签
    QuestionnaireTagComponent.prototype.selectTag = function (i) {
        var inputContext = localStorage.getItem('inputContext') ? localStorage.getItem('inputContext') : '';
        var target = this.el.nativeElement.querySelector('.elem-' + i);
        if (target.classList.contains('active') == true) {
            this.renderer.removeClass(target, 'active');
            // this.selectedTagArray.splice(this.selectedTagArray.findIndex(item => item === this.questionnaireTagArray[i].description),1);
            // this.selectedTag = this.inputContext.replace(this.questionnaireTagArray[i].description+',', '');
            this.selectedTag = inputContext.replace(this.questionnaireTagArray[i].description + ',', '');
            localStorage.setItem('inputContext', this.selectedTag);
        }
        else {
            // this.renderer.addClass(target, 'active');
            // this.selectedTagArray.push(this.questionnaireTagArray[i].description);
            if (inputContext.length >= 300) {
                return false;
            }
            else {
                this.renderer.addClass(target, 'active');
                this.selectedTag = inputContext + this.questionnaireTagArray[i].description + ',';
                // this.selectedTag += this.questionnaireTagArray[i].description+',';
            }
        }
        this.outPutSelectedTag.emit(this.selectedTag);
    };
    return QuestionnaireTagComponent;
}());
export { QuestionnaireTagComponent };



// WEBPACK FOOTER //
// ./src/app/app-questionnaire/questionnaire-tag/questionnaire-tag.component.ts.pre-build-optimizer.js